export const switchcase =
  <T>(cases: Record<string, T>) =>
  (defaultCase: T) =>
  (key: string) =>
    cases[key] ? cases[key] : defaultCase;
